import React from 'react';
import style from './style.scss'


const Textarea = (props) => {
    const {field} = props;

    return (
        <div >
            <label
                htmlFor={field.elementId}
                className={style.formLabel}
            >
                {field.label}{field.required&&<span className={style.asterisk}> *</span>}
            </label>
            <textarea
                className={style.fieldTextarea}
                id={field.elementId}
                name={field.name}
                value={field.value}
                placeholder={field.placeholder}
                {...props} >{field.value}</textarea>
        </div>
    )
}

export default Textarea;
